import AdderModel from "@/components/Forms/Gym/models/adderModel";
import ManagerModel from "@/components/Forms/Gym/models/managerModel";

class GymModel {
  name = null;
  adders = [];
  managers = [];

  constructor(gymDataRaw) {
    if (gymDataRaw !== undefined) {
      let gymData = JSON.parse(JSON.stringify(gymDataRaw));
      let { name, adders, managers } = gymData;
      this.name = name;
      this.adders = adders.map(adder => new AdderModel(adder));
      this.managers = managers.map(manager => new ManagerModel(manager));
    }
  }
}

export default GymModel;
